// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...
	$w('#productPage1').getProduct()
	.then( (product) => {
		let productName = product.name;
		let productDescription = product.description;
		// see example product object below
		console.log("Product Name = " + product.name);
		console.log("Product ID = " + product._id);
	} )
	.catch( (error) => {
		console.log(error);
	} );
});